// extracted by mini-css-extract-plugin
export var infoRow = "_rn-2";
export var labelContainer = "_rn-0";
export var rightInfo = "_rn-1";